import "./ProjectTreeRowComment.css";

import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";

const ProjectTreeRowComment = ({ rowObj, callbacks }) => {
	return (
		<span className="project-tree-comment" title="Показать комментарий" onClick={() => callbacks.showProjectTreeComment({ targetRow: rowObj })}>
			<CommentOutlinedIcon />
		</span>
	);
};

export default ProjectTreeRowComment;
